import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SmartFilter from './smart-filter';
import Tooltip from '../tooltip';
import { SmartFiltersContainer } from './smart-filters.style';
import { SMART_FILTER_TYPES, TOOLTIP_MESSAGES } from '../../../../constants';
import loadCount from '../../../../shapes/load-count';

/**
 * The smart filter component
 * @param {object} props - Object containing the props for this component
 * @param {string} props.initialFilter - The initial filter to apply
 * @param {string} props.updateFilters - Function to update smart filter in filters array
 * @param {object} props.smartFilterCounts - Count object for loads with problems and late loads
 * @return {element}
 */
const SmartFilters = ({ initialFilter, updateFilters, smartFilterCounts }) => {
  // State hook
  const [selectedFilter, setSelectedFilter] = useState(initialFilter);

  /**
   * Handles when a filter has changed
   * @param {string} fieldId  - FieldId of the updated filter
   * @return {void}
   */
  const handleUpdateFilters = (fieldId) => {
    setSelectedFilter(fieldId);
    updateFilters(fieldId);
  };
  return (
    <SmartFiltersContainer data-testid="Smart Filters">
      <Tooltip
        content={TOOLTIP_MESSAGES['smart-filter-late']}
        position="bottom"
        delay={1.0}
      >
        <SmartFilter
          fieldId={SMART_FILTER_TYPES.lateLoads}
          label="Late Loads"
          handleUpdateFilters={handleUpdateFilters}
          smartFilterCount={smartFilterCounts.lateLoadCount}
          isActive={selectedFilter === SMART_FILTER_TYPES.lateLoads}
        />
      </Tooltip>
      <Tooltip
        content={TOOLTIP_MESSAGES['smart-filter-within-two-hours']}
        position="bottom"
        delay={1.0}
      >
        <SmartFilter
          fieldId={SMART_FILTER_TYPES.withinTwoHours}
          label="Loads Within Two Hours"
          handleUpdateFilters={handleUpdateFilters}
          smartFilterCount={smartFilterCounts.withinTwoHoursCount}
          isActive={selectedFilter === SMART_FILTER_TYPES.withinTwoHours}
        />
      </Tooltip>
      <Tooltip
        content={TOOLTIP_MESSAGES['smart-filter-problems']}
        position="bottom"
        delay={1.0}
      >
        <SmartFilter
          fieldId={SMART_FILTER_TYPES.loadsWithProblems}
          label="Loads With Problems"
          handleUpdateFilters={handleUpdateFilters}
          smartFilterCount={smartFilterCounts.problemLoadCount}
          isActive={selectedFilter === SMART_FILTER_TYPES.loadsWithProblems}
        />
      </Tooltip>
      <SmartFilter
        fieldId={SMART_FILTER_TYPES.allLoads}
        label="All Loads"
        handleUpdateFilters={handleUpdateFilters}
        isActive={selectedFilter === SMART_FILTER_TYPES.allLoads}
      />
    </SmartFiltersContainer>
  );
};
SmartFilters.propTypes = {
  initialFilter: PropTypes.string,
  updateFilters: PropTypes.func.isRequired,
  smartFilterCounts: loadCount,
};

SmartFilters.defaultProps = {
  initialFilter: SMART_FILTER_TYPES.allLoads,
  smartFilterCounts: {
    problemLoadCount: 0,
    lateLoadCount: 0,
    withinTwoHoursCount: 0,
  },
};

export default SmartFilters;
